import { render, staticRenderFns } from "./LegacyRowSelectionComponent.vue?vue&type=template&id=51ae92f9&"
import script from "./LegacyRowSelectionComponent.vue?vue&type=script&lang=ts&"
export * from "./LegacyRowSelectionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ae92f9')) {
      api.createRecord('51ae92f9', component.options)
    } else {
      api.reload('51ae92f9', component.options)
    }
    module.hot.accept("./LegacyRowSelectionComponent.vue?vue&type=template&id=51ae92f9&", function () {
      api.rerender('51ae92f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/models/Table/Legacy/LegacyRowSelectionComponent.vue"
export default component.exports